export const mutations = {
  UPDATE_APPLICATION (state, payload) {
    state.application = { ...state.application, ...payload };
    const applicationId = payload.ua_icapplicationid;

    try {
      localStorage.setItem('selectedApplicationId', applicationId);
    } catch (e) {
      console.warn('Failed to save applicationId to localStorage:', e);
    }
  },
  UPDATE_APPLICATION_LIST (state, payload) {
    state.applicationList.items = payload;
  },
  UPDATE_ADDITIONAL_POSTCODE_FIELDS (state) {
    state.application.ua_tradingaddresspostcode = state.ua_tradingpostcode;
    state.application.ua_registeredaddresspostcode = state.ua_registeredpostcode;
  },
  UPDATE_CURRENT_STEP (state, payload) {
    state.application.ua_currentpageinapplication = payload;
  }
};
